module.exports = require('./helpers/bundle-url').getBundleURL('deub8') + "logo-dark.eefe0b7f.svg";